/**
 * @name 获取图片后缀携带的宽高信息
 * @param {string} name `width`或者`height`
 * @param {string} str 图片src
 */
export const getImgParam = (name, str) => {
  if (!str) return null;
  const regExp = `(${name})=([0-9]+)`;
  const reg = new RegExp(regExp, "i");
  const r = str.match(reg);
  if (r !== null) return r[2];
  return null;
};

/**
 * 获取图片的宽高尺寸，根据图片链接、宽或者高 来获取图片宽高信息
 * @param {string} src 图片链接上必须要存在图片的宽高信息
 * @param {string | number | undefined=} width
 * @param {string | number | undefined=} height
 */
export const getImageSize = (src, width, height) => {
  if (!src) {
    throw Error("图片链接不存在");
  }
  if (!width && !height) {
    throw Error("width或height至少需要一个");
  }
  // 1 有宽高直接返回宽高
  if (width && height) {
    return { width, height };
  }
  // 获取图片
  const src_width = getImgParam("width", src),
    src_height = getImgParam("height", src);

  // 图片链接上必须要存在图片的宽高信息
  if (!src_width || !src_height) {
    return { width, height };
  }

  if (width || !height) {
    // 只有宽则推导出高
    const real_width_number = parseFloat(width + "");
    const real_height_number = (real_width_number * Number(src_height)) / Number(src_width);
    const length = real_width_number.toString().length;
    const unit = (width + "").substring(length);
    return {
      width: width,
      height: unit ? `${real_height_number}${unit}` : real_height_number,
    };
  } else if (height) {
    // 只有高则推导出宽
    const real_height_number = parseFloat(height + "");
    const real_width_number = (real_height_number * Number(src_width)) / Number(src_height);
    const length = real_height_number.toString().length;
    const unit = (height + "").substring(length);
    return {
      width: unit ? `${real_width_number}${unit}` : real_width_number,
      height,
    };
  }
};

export const isIos = () => {
  return process.browser && /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
};

/**
 * 是否是Silvrrplus
 * @param {string} hostname url中hostname部分
 */
export function isSilvrrplus(hostname) {
  return hostname && hostname.indexOf("silvrrplus.com") > -1;
}

/**
 * 获取cookie options设置参数
 * @param {any} req 服务端
 */
export function getCookieOpts(req) {
  const hostname = process.server ? req.hostname : location.hostname;
  const opts =
    process.env.BUILD_ENV === "local"
      ? {}
      : {
          domain: isSilvrrplus(hostname) ? ".silvrrplus.com" : ".akulaku.com",
        };

  return opts;
}
